import { c as _c } from "react/compiler-runtime";
import { SkeletonLine } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
import { useTranslations } from "next-intl";
import { CheckboxFilterContent, CheckboxFilterContentItem, CheckboxFilterContentItemCheckbox, CheckboxFilterContentItemContent } from "./CheckboxFilterContent";
import { FilterPanel } from "./FilterPanel";
export function MarketplacePanelSkeleton(t0) {
  const $ = _c(6);
  const {
    open: t1
  } = t0;
  const open = t1 === undefined ? true : t1;
  const t = useTranslations("MarketplacePanel");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxFilterContent>{range(2).map(_temp)}</CheckboxFilterContent>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t) {
    t3 = t("marketplaces");
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== open || $[4] !== t3) {
    t4 = <FilterPanel content={t2} open={open}>{t3}</FilterPanel>;
    $[3] = open;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp(i) {
  return <CheckboxFilterContentItem key={i}><CheckboxFilterContentItemCheckbox /><CheckboxFilterContentItemContent><SkeletonLine className="w-full" /></CheckboxFilterContentItemContent></CheckboxFilterContentItem>;
}